import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  section: {
    '& + &': {
      marginTop: 32
    }
  },
  sectionTitle: {
    marginBottom: 12
  },
  sectionHint: {
    color: palette.shades[700],
    marginBottom: 12
  },
  fileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 340,
    overflowY: 'auto',
    scrollbarGutter: 'stable'
  },
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '8px 12px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white
  },
  fileMeta: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    flex: '1 1 40%',
    minWidth: 0
  },
  fileMetaText: {
    minWidth: 0,
    '& .MuiTypography-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  fileSize: {
    color: palette.shades[700]
  },
  filePropertyField: {
    flex: '1 1 55%',
    minWidth: 0
  },
  propertyItemText: {
    minWidth: 0,
    whiteSpace: 'normal'
  },
  propertyUtilities: {
    color: palette.shades[700]
  },
  emptyState: {
    padding: '16px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white,
    color: palette.shades[700],
    marginBottom: 12
  }
});
export default useStyles;